// src/ConveGroupMembers.tsx

import React from 'react';
import { GroupMember } from './types/groupChat';

interface Props {
  members: GroupMember[];
  currentUserId: number;
  isOnline: (userId: number) => boolean;
  onKick: (userId: number) => void;
  onLeave: () => void;
  isOwner: boolean;
}

const ROLE_LABEL: Record<string, string> = {
  OWNER: '방장',
  ADMIN: '관리자',
  MEMBER: '멤버',
};

const ConveGroupMembers: React.FC<Props> = ({
  members,
  currentUserId,
  isOnline,
  onKick,
  onLeave,
  isOwner,
}) => {
  return (
    <div className="conve-group-members-panel">
      <div className="conve-group-members-header">
        <span>멤버 ({members.length})</span>
      </div>

      <div className="conve-group-members-list">
        {members.map((member) => (
          <div key={member.id} className="conve-group-member-item">
            <div className="conve-member-avatar-wrap">
              <div className="conve-member-avatar">
                {member.userName ? member.userName[0].toUpperCase() : 'U'}
              </div>
              <span
                className={`conve-online-dot ${isOnline(member.userId) ? 'online' : 'offline'}`}
              />
            </div>
            <div className="conve-member-info">
              <div className="conve-member-name">
                {member.userName}
                {member.userId === currentUserId && (
                  <span className="conve-member-me"> (나)</span>
                )}
              </div>
              <div className="conve-member-role">{ROLE_LABEL[member.role] ?? member.role}</div>
            </div>
            {isOwner && member.userId !== currentUserId && member.role !== 'OWNER' && (
              <button
                className="conve-kick-btn"
                onClick={() => onKick(member.userId)}
                title="강퇴"
              >
                ✕
              </button>
            )}
          </div>
        ))}
      </div>

      <div className="conve-group-members-footer">
        <button className="conve-leave-btn" onClick={onLeave}>
          나가기
        </button>
      </div>
    </div>
  );
};

export default ConveGroupMembers;
